<div class="search-box text-small" [ngClass]="{
         'focused': focused
        }">
  <div class="inner">
    <input #searchInput id="search-input" (focus)="onFocus($event)" (focusout)="focusOut()" (keyup)="onKeyup($event)"
      (keydown)="onKeydown($event)"
      [(ngModel)]="keyword" autocomplete="off" maxlength="20" type="text" aria-label="Search"/>
    <!-- <span class="dn-icon-medium icon-search-1"></span> -->
    <span class="search-suggest" (click)="onSuggestClick()"
      [hidden]="focused || keyword !== ''">{{ placeholder }}</span>
    <span class="iconfont iconsousuo" (click)="search()"></span>
    <!-- <div class="submit text-center"
             (click)="search()"><i class="dn-icon-medium icon-search-1"></i></div> -->
    <div class="search-agent pb-2"
      [hidden]="!focused || (trendingSearch.length === 0 && searchHistory.length === 0 && instanceResult.length ===0)"
      >
      <div *ngIf="!instanceResult.length">
        <div class="hd-line text-light d-flex align-items-center" *ngIf="searchHistory.length">
          <span>历史搜索：</span>
          <div class="ml-auto link d-flex align-items-center clear-button" (click)="clearSearchHistory()">
            <span class="dn-icon-medium icon-ashbin"></span>
            <span>清空</span>
          </div>
        </div>
        <div class="search-history-item item px-3" *ngFor="let keyword of searchHistory"
          (click)="selectSearch(keyword.title)">
          {{keyword.title}}
        </div>
        <div *ngIf="trendingSearch && trendingSearch.length">
          <div class="hd-line text-light">热门搜索：</div>
          <div class="trending-search-item d-flex item px-3"
            *ngFor="let keyword of trendingSearch.slice(0, searchHistoryCount > 0 ? 10-searchHistoryCount : 9); let i = index"
            (click)="selectSearch(keyword.title)">
            <!-- <span class="trending-search-index mr-2"
              [ngClass]="{'rank1': i===0, 'rank2': i===1, 'rank3': i===2}">{{ i + 1 }}</span> -->
            <i class="mr-3 trending-number iconfont icon-{{ i + 1 }}"></i>
            <span class="flex-1">{{keyword.title}}</span>
          </div>
        </div>
      </div>
      <div *ngIf="instanceResult.length" class="pt-2">
        <div class="instance-result-item item px-3" [ngClass]="{'active':res.isActive}" *ngFor="let res of instanceResult" (click)="selectSearch(res.title)"
          [innerHTML]="res.title | wrap: ({search: keyword, class: 'text-red'})">
        </div>
      </div>
    </div>
    <!-- <app-rank-button></app-rank-button> -->
    <a routerLink="/rank" target="_blank" title="排行榜">
      <span class="iconfont iconpaihang2"></span>
    </a>
  </div>
</div>
